'use strict';

var _ = require('lodash');
var GridExportCsvButtonController = function GridExportCsvButtonController($scope) {
  var gridPanel = $scope.gridPanelScope;
  $scope.exportToCsv = function () {
    var data = gridPanel.jqxGridSettings.jqxGrid('getdisplayrows');
    if (_.isFunction($scope.makeExportToCsv)) {
      $scope.makeExportToCsv(data);
    }
  };
};
GridExportCsvButtonController.$inject = ['$scope'];
module.exports = GridExportCsvButtonController;